(function () {
  'use strict';
  const root = document.querySelector('.bjp-faceted-collection');
  if (!root) return;
  const form = root.querySelector('.bjp-filter-form');
  const sidebar = root.querySelector('.bjp-filter-sidebar');
  const dialog = root.querySelector('.bjp-filter-dialog');
  const opener = root.querySelector('.bjp-filter-open');
  const desktop = window.matchMedia('(min-width: 992px)');
  const results = root.querySelector('.bjp-catalog-results');
  let controller;
  let observer;
  let priceTimer;
  root.classList.add('bjp-filter-ready');

  function closeFilters() { if (dialog.open) dialog.close(); }
  dialog.addEventListener('close', function () { sidebar.append(form); opener.focus({preventScroll: true}); });
  dialog.addEventListener('click', function (event) { if (event.target === dialog) closeFilters(); });
  dialog.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    const stops = Array.from(dialog.querySelectorAll('button, a[href], input, summary')).filter(function (item) {
      return !item.disabled && item.getClientRects().length;
    });
    const first = stops[0];
    const last = stops[stops.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  opener.addEventListener('click', function () { dialog.append(form); dialog.showModal(); });
  desktop.addEventListener('change', function () { if (desktop.matches) closeFilters(); });

  function formUrl() {
    const url = new URL(window.location.href);
    Array.from(url.searchParams.keys()).forEach(function (key) {
      if (key.startsWith('filter.') || key === 'sort_by' || key === 'page') url.searchParams.delete(key);
    });
    new FormData(form).forEach(function (value, key) { if (String(value).trim()) url.searchParams.append(key, value); });
    return url;
  }

  function initCards() {
    ['btyAnimationImageLoad', 'btyHoverMediaVideo', 'btyQuickView', 'btyQuickAdd', 'btySwatch', 'btyAddToCart'].forEach(function (name) {
      if (typeof window[name] === 'function') window[name](results);
    });
    document.dispatchEvent(new CustomEvent('product-card-updated'));
  }

  function observeMore() {
    if (observer) observer.disconnect();
    const next = root.querySelector('[data-infinite] .bjp-load-more');
    if (!next) return;
    observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !controller) {
        observer.disconnect();
        update(new URL(next.href), {append: true});
      }
    }, {rootMargin: '120px'});
    observer.observe(next);
  }

  async function update(url, options) {
    options = options || {};
    if (controller) controller.abort();
    const request = new AbortController();
    controller = request;
    const openGroups = new Map(Array.from(form.querySelectorAll('details')).map(function (item) { return [item.dataset.filterKey, item.open]; }));
    const focusedId = form.contains(document.activeElement) ? document.activeElement.id : '';
    const scrollTop = form.querySelector('.bjp-filter-scroll').scrollTop;
    results.setAttribute('aria-busy', 'true');
    form.querySelector('[type="submit"]').disabled = true;
    const fetchUrl = new URL(url);
    fetchUrl.searchParams.set('section_id', root.dataset.id);
    try {
      const response = await fetch(fetchUrl, {signal: request.signal});
      if (!response.ok) throw new Error('Collection request failed');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextRoot = page.querySelector('.bjp-faceted-collection');
      if (!nextRoot) throw new Error('Collection section missing');
      if (request.signal.aborted) return;
      if (options.append) {
        results.querySelector('.products').insertAdjacentHTML('beforeend', nextRoot.querySelector('.products').innerHTML);
        results.querySelector('.bjp-catalog-pagination').innerHTML = nextRoot.querySelector('.bjp-catalog-pagination').innerHTML;
      } else {
        form.innerHTML = nextRoot.querySelector('.bjp-filter-form').innerHTML;
        form.querySelectorAll('details').forEach(function (item) {
          if (openGroups.has(item.dataset.filterKey)) item.open = openGroups.get(item.dataset.filterKey);
        });
        form.querySelector('.bjp-filter-scroll').scrollTop = scrollTop;
        results.innerHTML = nextRoot.querySelector('.bjp-catalog-results').innerHTML;
        root.querySelector('[data-bjp-count]').textContent = nextRoot.querySelector('[data-bjp-count]').textContent;
        root.querySelector('[data-bjp-active-count]').textContent = nextRoot.querySelector('[data-bjp-active-count]').textContent;
        if (!options.history) window.history.pushState({}, '', url);
        if (focusedId) {
          const focusTarget = document.getElementById(focusedId);
          if (focusTarget && !focusTarget.disabled) focusTarget.focus({preventScroll: true});
        }
        root.querySelector('.bjp-filter-status').textContent = root.querySelector('[data-bjp-count]').textContent;
      }
      initCards();
      if (options.close) closeFilters();
    } catch (error) {
      if (error.name !== 'AbortError') window.location.assign(url);
    } finally {
      if (controller === request) {
        controller = null;
        results.removeAttribute('aria-busy');
        form.querySelector('[type="submit"]').disabled = false;
        observeMore();
      }
    }
  }

  form.addEventListener('input', function (event) {
    if (event.target.type !== 'number') return;
    clearTimeout(priceTimer);
    priceTimer = setTimeout(function () { if (form.checkValidity()) update(formUrl()); }, 500);
  });
  form.addEventListener('change', function () {
    clearTimeout(priceTimer);
    if (form.reportValidity()) update(formUrl());
  });
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    clearTimeout(priceTimer);
    if (form.reportValidity()) update(formUrl(), {close: true});
  });
  root.addEventListener('click', function (event) {
    if (event.target.closest('.bjp-filter-close')) { closeFilters(); return; }
    const link = event.target.closest('[data-bjp-filter-link], .bjp-catalog-pagination a');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    update(new URL(link.href), {append: link.classList.contains('bjp-load-more')});
  });
  window.addEventListener('popstate', function () { update(new URL(window.location.href), {history: true}); });
  observeMore();
})();
